
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
__webpack_public_path__ = '/';

 require('./bootstrap');
 import { createApp } from 'vue';
 import App from './components/App.vue'; // 正しいVueコンポーネントをインポート
 import { createStore } from 'vuex';
 import { createI18n } from 'vue-i18n';
 import Locales from './vue-i18n-locales.generated';
 //import VueRouter from 'vue-router';
 import { createRouter, createWebHistory } from 'vue-router';
 import queryString from 'query-string';
 import VueHead from 'vue-head';
import Web3 from 'web3';
import { Buffer } from 'buffer';
import process from 'process/browser';
import Login from "./components/pages/Auth/Login.vue"; // login.vue をインポート

 window.Buffer = Buffer;
 window.process = process;
 

const store = createStore({
    state: {
        // ここに初期状態を定義（必要に応じて）
    },
    mutations: {
        // ここにミューテーションを定義（必要に応じて）
    },
    actions: {
        // ここにアクションを定義（必要に応じて）
    },
    plugins: [
        //vuexI18n.plugin
    ]
});
// Initialize Vuex I18n
// Vue I18n の設定
const i18n = createI18n({
    legacy: false, // レガシーモードを無効にする
    locale: 'ja', // デフォルトロケール
    messages: {
        ja: Locales.ja,
        en: Locales.en
    }
});

if (document.domain.match(/world/)) {
    i18n.global.locale.value = 'en';
} else {
    i18n.global.locale.value = 'ja';
}


// Vue.component('login',require("./components/pages/Auth/Login.vue").default);

// Initialize Vue Router
const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: '/assets', component: () => import('./components/pages/Assets/Index.vue') },
        { path: '/assets/lists', component: () => import('./components/pages/Assets/List.vue') },
        { path: '/assets/lists/:sort', component: () => import('./components/pages/Assets/List.vue'),props: true },
        { path: '/tokens', component: () => import('./components/pages/Assets/TokenList.vue') },
        //{ path: '/asset/:id', component: () => import('./components/pages/Assets/Asset.vue'),props: true },
        { 
            path: '/asset/:id', 
            component: () => import('./components/pages/Assets/Asset.vue'),
            props: route => ({
                id: route.params.id,
                tokens: window.App.tokens, // グローバル変数から tokens を取得
                user: window.App.user      // グローバル変数から user を取得
            })
        },
        //{ path: '/token/:id', component: () => import('./components/pages/Assets/Token.vue'),props: true },
        { path: '/token/:id', component: () => import('./components/pages/Assets/Token.vue'), 
            props: route => ({
            id: route.params.id,
            user: route.query.user
           })
        },
        { path: '/user/:page', component: () => import('./components/pages/Auth/Mypage.vue'),props: true },
        // { path: '/wallet/:address', component: () => import('./components/pages/Wallet.vue') },
        { 
            path: '/login', 
            component: Login // ログインルートを追加
        },
    ],
    
    
    parseQuery: (query) => {
        return queryString.parse(query, {
            arrayFormat: 'bracket'
        });
    },
    stringifyQuery: (params) => {
        if (Object.keys(params).length === 0) {
            return '';
        }
        return '?' + queryString.stringify(params, { arrayFormat: 'bracket' });
    }
});
// Initialize Vue Analytics
if (document.getElementById('app')) {
    // window.App が存在するか確認し、デフォルト値を設定
    window.App = window.App || {};
    window.App.tokens = window.App.tokens || {};
    window.App.user = window.App.user || {};
    
    // Vue アプリケーションの作成
    const app = createApp(App);

    // グローバルプロパティとしてデータを設定
    app.config.globalProperties.$tokens = window.App.tokens;
    app.config.globalProperties.$user = window.App.user;

    
    app.component('login', Login);

    app.use(store);
    app.use(router);
    app.use(i18n); // `vue-i18n` を使用
    app.use(VueHead);
    // コンポーネントのグローバル登録


    /*
    app.use(VueGtag, {
        property: {
            id: 'UA-116316574-1X' // あなたのGoogle AnalyticsトラッキングID
        }
    });
    */
    // Laravel Blade から渡されたデータを取得
    //app.provide('initialData', JSON.parse(document.getElementById('app').dataset.initialData));

    app.mount('#app');
    //mix.sourceMaps();
    app.config.errorHandler = (err, vm, info) => {
        console.error('Vueエラーハンドラー:', err, info);
    };
}
